import * as React from 'react';
import * as ReactDOM from 'react-dom';

/* Navigation Components */
import { createBrowserHistory } from 'history';
import { Route, Router, Switch } from 'react-router'

import { EnvironmentSwitch, EnvironmentSwitchFilterType } from './Misc/EnvironmentSwitch'

/* Core Core Components */
import App from './App/App'
import LoginPage from './LoginPage';
import InterestPage from './InterestPage';

/* Visual Test Components */
import AvatarVisual from './App/Elements/Avatar.visual'
import BrowserVisual from './App/Blocks/Browser.visual'
import ToolCardVisual from './App/Elements/ToolCard.visual'
import SearchBoxVisual from './App/Blocks/SearchBox.visual'
import UserMenuVisual from './App/Blocks/UserMenu.visual'
import CoreVisual from './App/Core.visual'

import registerServiceWorker from './registerServiceWorker';

const browserHistory = createBrowserHistory();

(window as any).API_LOCATION = process.env.REACT_APP_API_URL || "http://localhost:8080";

const RoutedCoreVisual = ({ match }: { match: any }) => {
  return <CoreVisual resolution={match.params.resolution} />
};

ReactDOM.render(
  <Router history={browserHistory}>
    <Switch>
      <Route exact={true} path="/" component={App}/>
      <Route exact={true} path="/login" component={LoginPage}/>
      <Route exact={true} path="/interest" component={InterestPage}/>

      <EnvironmentSwitch filter="production" filterType={EnvironmentSwitchFilterType.isNot}>
        <Switch>
          <Route exact={true} path="/app/Avatar" component={AvatarVisual}/>
          <Route exact={true} path="/app/Browser" component={BrowserVisual}/>
          <Route exact={true} path="/app/ToolCard" component={ToolCardVisual}/>
          <Route exact={true} path="/app/UserMenu" component={UserMenuVisual}/>
          <Route exact={true} path="/app/SearchBox" component={SearchBoxVisual}/>

          <Route path="/app/:resolution" component={RoutedCoreVisual} />
        </Switch>
      </EnvironmentSwitch>
    </Switch>
  </Router>,
  document.getElementById('root') as HTMLElement
);

try {
  registerServiceWorker();
  (window as any).SERVICE_WORKER_REGISTERED = true;
} catch {
  (window as any).SERVICE_WORKER_REGISTERED = false;
}



// WEBPACK FOOTER //
// ./src/index.tsx